import { jsx as _jsx } from "react/jsx-runtime";
import { useModalContext } from "@chakra-ui/modal";
import { IconButton } from "@chakra-ui/react";
import { IoCloseOutline } from "react-icons/io5";
const CustomDrawerCloseButton = () => {
    const { onClose } = useModalContext();
    return (_jsx(IconButton, { colorScheme: "gray", fontSize: "2xl", variant: "ghost", position: "absolute", top: 5, insetEnd: 3, onClick: onClose, icon: _jsx(IoCloseOutline, {}), "aria-label": "close" }));
};
export default CustomDrawerCloseButton;
